import { Outlet } from '@tanstack/react-router'
import Sidebar from '@/features/navbar/components/Sidebar'
import MobileNavigation from '@/features/navbar/components/MobileNavigation'

export default function AuthedLayout() {
  return (
    <div className="h-screen overflow-hidden">
      <div className="flex h-full">
        {/* Desktop Sidebar */}
        <div className="hidden lg:block w-60 h-full">
          <Sidebar />
        </div>

        {/* Main Content */}
        <div className="flex-1 flex flex-col min-w-0">
          <main className="flex-1 p-4 lg:p-6 overflow-auto pb-20 lg:pb-4">
            <div className="max-w-full">
              <Outlet />
            </div>
          </main>
        </div>
      </div>

      {/* Mobile Navigation */}
      <MobileNavigation />
    </div>
  )
}
